import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatCurrency } from '../../../utils/FormatCurrency';
import { Info } from 'lucide-react';
import { CustomButton, YellowButton } from '../../../utils/Button';
import { getTotalCartPrice } from '../../../features/cart/cartSlice';
import { getUserIsAuthenticated } from '../../../features/auth/authSlice';
import { BVNUpload } from '../../../pages/cartItems/cartItemsContent/UploadFileModal';
import { set } from 'date-fns';

export const Subtotal = ({
  isValid,
  needToUpgrade,
  subTotal,
  shouldDisableCheckout,
}) => {
  const [isUpgraded, setIsUpgraded] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const cart = useSelector((state) => state.cart);
  const isAuthenticated = useSelector(getUserIsAuthenticated);
  const [successModalIsOpen, setSuccessModalIsOpen] = useState(false);

  const handleCheckout = () => {
    navigate('/cart-items/checkout');
  };
  const user = useSelector((state) => state.user);
  const isTier2 = user?.data?.isTier2;

  const handleUpgrade = () => {
    setIsUpgraded(true);
  };
  const openModal = () => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const closeSuccessModal = () => {
    setSuccessModalIsOpen(false);
  };

  return (
    <article className="py-5 px-5 pt-2 shadow bg-white">
      <div className="flex items-center justify-between mb-4">
        <p>Subtotal</p>
        <p>{formatCurrency(subTotal)}</p>
      </div>
      {!isValid && (
        <div className="flex items-center space-x-1 text-sm text-red-500 mb-3 font-duplet justify-center">
          <Info size={12} />
          <span>All items should have the same payment plan</span>
        </div>
      )}
      {needToUpgrade && (
        <div className="w-[100%] mx-auto mb-4">
          <p className="text-sm mb-2">
            The item(s) in your cart is valued above{' '}
            <strong>{formatCurrency(500000)} </strong>
            and you you are required to upgrade to Tier 2 to access installment
            limit up to <strong>{formatCurrency(1000000)}</strong>.
          </p>

          <YellowButton onClick={openModal}>
            {isAuthenticated ? 'Upgrade now' : 'Sign in to upgrade'}
          </YellowButton>
        </div>
      )}

      <div className="w-[100%] mx-auto">
        <CustomButton
          onClick={handleCheckout}
          text="Check Out"
          borderRadius="40px"
          disabled={!isValid || shouldDisableCheckout}
          width="100%"
        />
      </div>

      <div className="w-52">
        <BVNUpload
          onUpgrade={handleUpgrade}
          closeModal={closeSuccessModal}
          modalIsOpen={modalIsOpen}
        />
      </div>
    </article>
  );
};
